<template>
  <div>
    <a-form
      :form="form"
      class="registery-form"
    >
      <a-form-item
        label="手机号码"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-input
          v-decorator="['mobile', {initialValue: registeryForm.mobile, rules: [{ required: true, validator: cellTelValidator}]}]"
          placeholder="请输入手机号码"
          :max-length="11"
          @change="getFieldsValueData(true)"
        />
      </a-form-item>
      <a-form-item
        label="验证码"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-input
          v-decorator="['picCaptcha', 
          {initialValue: registeryForm.picCaptcha,
          rules: [{ required: true, message: '请输入图片验证码', whitespace: true}]}]"
          placeholder="请输入右图中的字符"
          :max-length="4"
          class="suffix-right"
          @change="getFieldsValueData(true)"
        >
          <div slot="suffix" class="imgbox" @click="getForgetImg">
            <img :src="pic" alt />
          </div>
        </a-input>
      </a-form-item>
      <a-form-item
        label="短信验证"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-input
          v-decorator="['smsCaptcha', {initialValue: registeryForm.smsCaptcha,rules: [{ required: true, message: '请输入短信验证码', whitespace: true}]}]"
          placeholder="请输入短信验证码"
          :max-length="6"
          class="suffix-right"
          @change="getFieldsValueData()"
        >
          <div slot="suffix" class="countdown">
            <a-button class="code-btn" type="primary" :disabled="disabled" @click="getCode">
              <span v-if="!deadline">发送验证码</span>
              <a-statistic-countdown
                v-else
                :value="deadline"
                format="重新发送ss秒"
                :value-style="valueStyle"
                @finish="timeFinish"
              />
            </a-button>
          </div>
        </a-input>
      </a-form-item>
      <a-form-item
        label="登录密码"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-input-password
          v-decorator="['password', {initialValue: registeryForm.password,rules: [{ required: true, validator: passwordValidator}]}]"
          placeholder="请设置登录密码"
          @change="getFieldsValueData()"
        >
        </a-input-password>
      </a-form-item>
      <a-checkbox class="agreement" :checked="checked" @change="changeChecked">
        <span>同意并遵守<a @click.prevent="showTerms('service')">《服务条款》</a>和<a @click.prevent="showTerms('privacy')">《隐私条款》</a></span>
      </a-checkbox>
      <div class="login-submit">
        <a-button
          :loading="loading"
          size="large"
          class="login-btn"
          html-type="submit"
          type="primary"
          :disabled="carryOut || !checked"
          @click="registerySubmit"
        >
          注册账号
        </a-button>
      </div>
    </a-form>
    <a-modal v-model="visible" width="880px" dialog-class="terms-modal" title="服务条款">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleChecked">
          同意并继续
        </a-button>
      </template>
      <iframe class="terms" :src="TERMSURL[termsType]" />
    </a-modal>
  </div>
</template>

<script>
import { cellTelValidator, passwordValidator } from '@/utils/validate'
import md5 from 'js-md5';
import { getPicCaptcha, getSmsCaptcha, accountRegister } from '../api/auth/index'
import { SMSTYPE, TERMSURL } from '../constant'

const PicArray = [
  {
    KEY: "picCaptcha",
    VALUE: "验证码",
  },
  {
    KEY: "mobile",
    VALUE: "手机号不存在",
  },
  {
    KEY: "mobile",
    VALUE: "该货主已被禁用",
  },
];

export default {
  name: 'RegisteryForm',
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      disabled: true,
      registeryForm: {
        mobile: '', // 手机号
        picCaptcha: '', // 图形验证
        smsCaptcha: '', // 短信验证
        password: '', // 密码
      },
      valueStyle: {
        "font-size": "14px",
      },
      pic: null,
      picKey: "",
      deadline: 0,
      carryOut: true,
      checked: false, // 同意条款
      visible: false, // 条款弹窗
      TERMSURL,
      termsType: '', // 条款类型
    }
  },
  created() {
    this.getForgetImg();
  },
  methods: {
    cellTelValidator,
    passwordValidator,
    registerySubmit() {
      const formData = this.form.getFieldsValue();
      const params = {
        mobile: formData.mobile,
        password: md5(formData.password),
        smsCaptcha: formData.smsCaptcha,
        channel: 'WEB_REGISTER'
      }
      accountRegister(params).then(() => {
        this.$emit('register')
      })
    },
    showTerms(type) {
      // e.preventDefault()
      this.visible = true
      this.termsType = type
    },
    handleChecked() {
      this.checked = true
      this.visible = false
    },
    getCode() {
      this.form.validateFields(["mobile", "picCaptcha"], (error) => {
        if (!error) {
          const formData = this.form.getFieldsValue();
          const upData = {
            picCaptcha: formData.picCaptcha,
            picKey: this.picKey,
            mobile: formData.mobile,
            smsType: SMSTYPE.register,
          };
          getSmsCaptcha(upData).then(() => {
            this.$message.success("验证码发送成功");
            this.disabled = !this.disabled;
            this.deadline = Date.now() + 1000 * 60;
          }).catch((err) => {
            this.errorMsg(err, PicArray)
            this.getForgetImg()
          });
        }
      });
    },
    getForgetImg() {
      getPicCaptcha({
        smsType: SMSTYPE.register
      }).then((res) => {
        this.pic = res.pic;
        this.picKey = res.picKey;
      });
    },
    changeChecked(e) {
      this.checked = e.target.checked
      // this.getFieldsValueData()
    },
    getFieldsValueData(isPic) {
      this.$nextTick(() => {
        const formData = this.form.getFieldsValue();
        const value = Object.values(formData);
        if (value.includes("")) {
          this.carryOut = true;
        } else {
          this.form.validateFields(["password"],err => {
            if (err) {
              this.carryOut = true
            } else {
              this.carryOut = false
            }
          })
        }
        if (isPic) {
          this.form.validateFields(["mobile", "picCaptcha"],err => {
            if (err) {
              this.disabled = true
            } else {
              this.disabled = false
            }
          })
        }
      });
    },
    timeFinish() {
      this.deadline = 0
      this.disabled = !this.disabled;
    },
  }
}
</script>

<style lang="less" scoped>
.registery-form {
  margin-top: 4vh;
  .agreement {
    display: block;
    margin: -10px auto 14px auto;
    text-align: center;
  }
  @media screen and (min-width: 1921px) {
    .agreement {
      margin: 30px auto 50px auto;
    }
  }
  .countdown {
    .ant-btn-primary {
      box-shadow: none;
    }
  }
  ::v-deep {
    .ant-form-item-label {
      text-align: left;
    }
    .ant-form-item {
      label {
        color: #606266;
      }
      .ant-form-item-label {
        > label::after, label::before {
          content: '';
        }
      }
    }
  }
  .suffix-right {
    ::v-deep {
      .ant-input-suffix {
        right: 0px;
        display: inline-block;
        width: 96px;
        height: 40px;
      }
      .ant-statistic-content {
        color: #fff;
      }
    }
  }
  .code-btn {
    height: 40px;
    width: 96px;
    padding: 0;
  }
  .imgbox {
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    img {
      width: 100%;
      height: 100%;
      &:hover{
        cursor: pointer;
      }
    }
  }
}
.terms {
  border: none;
  width: 100%;
  // height: 100%;
  height: 508px;
}
</style>
<style lang="less">
.terms-modal {
  .ant-modal-content {
    border-radius: 16px;
     .ant-modal-header {
      background: #F4F5F6;
      border-radius: 16px 16px 0px 0px;
      padding: 0px 16px;
      .ant-modal-title {
        line-height: 48px;
      }
    }
    .ant-modal-body {
      padding: 0;
      // max-height: 506px;
      // overflow-y: auto;
      // padding: 16px 24px;
    }
    .ant-modal-footer {
      text-align: center;
      padding-bottom: 19px;
      padding-top: 15px;
      // border-top: none;
      .ant-btn {
        width: 400px;
        height: 54px;
        background: #06B880;
        border-radius: 4px;
      }
    }
  }
}
</style>
